<section id="services" class="services section">
  <div class="container" data-aos="fade-up" data-aos-delay="100">

    <div class="row gy-5" *ngIf="serviciosVisibles.length > 0">

      <div  *ngFor="let item of serviciosVisibles" class="col-xl-4 col-md-6" data-aos="zoom-in" data-aos-delay="200" >
        <div class="service-item">
          <div class="img">
            <img src="assets/img/services/services-1.jpg" class="img-fluid" alt="">
          </div>
          <div class="details position-relative">
            <div class="icon">
              <i class="bi bi-activity"></i>
            </div>
            <a href="service-details.html" class="stretched-link">
              <h3>{{ convertirPrimeraLetraMayuscula(item.serv_nombre) }}</h3>
            </a>
            <p>Provident nihil minus qui consequatur non omnis maiores. Eos accusantium minus dolores iure perferendis.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center" *ngIf="serviciosVisibles.length < servicios.length">
      <button (click)="cargarMas()" class="btn btn-primary viewMore">Ver más</button>
    </div>

  </div>

</section><!-- /Services Section -->
